// src/navigation/ProfessorPrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROLE_PROFESSOR } from '../constants/roles';

const ProfessorPrivateRoute = ({ element }) => {
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const role = useSelector((state) => state.auth.user?.role);

    if (!isAuthenticated) {
        return <Navigate to="/connexion" replace />;
    }

    if (role !== ROLE_PROFESSOR) {
        return <Navigate to="/accueil" replace />;
    }

    return element;
};

export default ProfessorPrivateRoute;
